export default class KeyValue {
    constructor(key,values) {
        this.key = key;
        this.values = values;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.values)) { if(!value) { result = false; break; } }

        if(result) result = Boolean(this.key);

        return result;
    }
}